import HeaderProps from "./_header-props";
import HeaderBackground from "./_header-background";
import HeaderShared from "./_header-shared";
import HeaderButtonColors from "./_header-button-colors";
import HeaderLogo from "./_header-logo";

class _headerToggles {
  /*
   * Connects all the header buttons to the appropriate list transitions
   * */
  connectHeaderToggleToListTransitions($toggle) {
    // get the target id from the data-header-toggle attribute
    // because these toggles are not inside the actual transition list,
    // they should contain the id of the transition list
    const target = $toggle.dataset.headerToggle;

    // The target element has to be found through the id stored in the target submenu.
    // because the target of the header toggle could be a child of the transition list,
    // the closest transition list upstream is searched for
    const $target = HeaderProps.$header
      .querySelector(`#${target}`)
      ?.closest("[data-list-transition]");

    // set the custom value for the data-list-transition-item attribute on sub menu toggles
    this.setupCustomDelayValuesForSubMenuToggles($target);

    $toggle.addEventListener("click", (_) => {
      // if the toggle has no target, an error is thrown to the console
      console.assert(target, "data-header-toggle must have a target");

      // the root-nav is handled in another place
      if (target === "root-nav") {
        return;
      }

      // if $target was not found, warn the user and stop the method from further execution
      if (!$target) {
        console.warn(`Could not find target for header toggle`);
        return;
      }

      const state = $target.triggerTransition();
      if (state === "open") {
        const $rootNav = HeaderProps.$header.querySelector("#root-nav");
        $rootNav.markListAsOpen();
        HeaderLogo.switchToDetailedLogo();
      }

      HeaderButtonColors.setVisualStateOfDesktopToggles(target, state);

      const mobileNavActive = matchMedia(
        `(max-width: ${HeaderProps.breakPoint})`
      ).matches;
      const sublistsHaveToggle = !!$target.querySelector(
        "[data-list-transition-toggle]"
      );
      if (mobileNavActive && sublistsHaveToggle) {
        $target.closeSublists();
      }

      // if the target is the element that is opening, then close other sections
      HeaderShared.closeSiblingLists($target);

      // handle the collapsing of the header
      HeaderBackground.handleHeaderCollapse();
    });
  }

  /*
   * sets the custom value for the data-list-transition-item attribute on sub menu toggles
   * on desktop this will be: 'first'
   * on mobile this wil be the index of the toggle within the target (section menu)
   */
  setupCustomDelayValuesForSubMenuToggles($target) {
    const $children = $target.querySelectorAll("[data-list-transition-item]");
    const $directChildren = [...$children].filter(
      ($child) => $child.closest("[data-list-transition]") === $target
    );
    const mobileNavActive = matchMedia(
      `(max-width: ${HeaderProps.breakPoint})`
    ).matches;
    $directChildren.forEach(($child, i) => {
      if (mobileNavActive) {
        $child.dataset.listTransitionItem = (i + 1).toString();
      } else {
        $child.dataset.listTransitionItem = "first";
      }
    });
  }

  /*
   * Sets up all the header toggles
   */
  setup() {
    const $headerToggles = HeaderProps.$header?.querySelectorAll(
      "[data-header-toggle]"
    );
    $headerToggles?.forEach(($toggle) => {
      if (
        $toggle.dataset.headerToggle === "root-nav" ||
        !$toggle.dataset.headerToggle
      ) {
        return;
      }
      this.connectHeaderToggleToListTransitions($toggle);
    });
  }
}

export default new _headerToggles();
